import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { setDecimals } from 'src/app/utils/decimal';
import { v4 as uuidv4 } from 'uuid';
import * as writtenNumber from 'written-number';
import { xml2js } from 'xml-js';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { ComponentsService } from '../components/components.service';

@Injectable({
    providedIn: 'root'
})
export class DteService {

    constructor(
        private http: HttpClient,
        public auth: AuthService,
        public components: ComponentsService
    ) {

    }

    async signDte(json: any, type = 'reception') {

        return new Promise(async (resolve, reject) => {
            const certificado = await this.recuperarCertificado(json);
            if (certificado) {

                let postData = {
                    private_key: certificado.privateKey.encodied._text,
                    jsonData: json.dteJson,
                }

                this.http.post(`${environment.api}/sign_json`, postData).subscribe(response => {
                    let signed_json = response['token'];

                    let authPostData = {
                        user: this.auth.account_data.fiscal.nit,
                        pwd: this.auth.account_data.fiscal.passwordMH
                    };


                    this.http.post(`${environment.mh.url}/seguridad/auth?user=${authPostData.user}&pwd=${authPostData.pwd}`, {}).subscribe(response => {
                        const headers = {
                            Authorization: `${response['body']['token']}`,
                        };

                        if (type == 'reception') {
                            this.http.post(`${environment.mh.url}/fesv/recepciondte`, {
                                "ambiente": environment.mh.environment,
                                "idEnvio": "01",
                                "version": json.dteJson.identificacion.version,
                                "tipoDte": json.dteJson.identificacion.tipoDte,
                                "documento": signed_json,
                                "codigoGeneracion": json.dteJson.identificacion.codigoGeneracion
                            }, {
                                headers: headers
                            }).subscribe(response => {
                                console.log(response);
                                resolve(response);
                            }, err => {
                                console.log(err);

                                reject({ error: err, msg: err.error.descripcionMsg });
                                // reject({ error: err, msg: "NO SE HA PROPORCIONADO DATOS PARA VALIDAR" });
                            })
                        } else if (type == 'invalidation') {
                            this.http.post(`${environment.mh.url}/fesv/anulardte`, {
                                "ambiente": environment.mh.environment,
                                "idEnvio": "02",
                                "version": json.dteJson.identificacion.version,
                                "documento": signed_json,
                            }, { headers: headers }).subscribe(response => {
                                resolve(response);
                            }, err => {
                                reject({ error: err, msg: err.error.descripcionMsg });
                            })
                        } else if (type == 'contingency') {
                            this.http.post(`${environment.mh.url}/fesv/contingencia`, {
                                "nit": this.auth.account_data.fiscal.nit,
                                "documento": signed_json,
                            }, { headers: headers }).subscribe(response => {
                                resolve(response);
                            }, err => {
                                reject({ error: err, msg: err.error.descripcionMsg });
                            })
                        }
                    }, err => {
                        reject({ error: err, msg: '' });
                    });

                }, err => {
                    reject({ error: err, msg: '' });
                })
            } else {
                reject({ error: '', msg: 'La contraseña no es válida o el certificado no se pudo recuperar' });
            }
        })
    }

    encrypt(p: string): string {
        const diget = CryptoJS.algo.SHA512.create();
        diget.update(p);
        const encodedhash = diget.finalize();
        return this.bytesToHex(encodedhash);
    }

    private bytesToHex(hash: any): string {
        let hexString = '';
        for (let i = 0; i < hash.words.length; i++) {
            const word = hash.words[i];
            const byteLen = 4;
            for (let j = 0; j < byteLen; j++) {
                const byte = (word >> (24 - j * 8)) & 0xff;
                const hex = byte.toString(16).padStart(2, '0');
                hexString += hex;
            }
        }
        return hexString;
    }

    async recuperarCertificado(json: any): Promise<any | null> {
        try {
            const xmlOptions = { compact: true, spaces: 4 }; // Opciones para la conversión XML a JS
            const crypto = this.encrypt(json.passwordPri);
            const contenido = this.auth.account_data.fiscal.certificate;
            const certificadoObj: any = xml2js(contenido, xmlOptions);

            const certificado: any = certificadoObj.CertificadoMH;

            if (certificado.privateKey.clave._text === crypto) {
                return certificado;
            } else {
                console.log(`Password no válido: ${certificado.nit._text}`);
                return null;
            }
        } catch (error) {
            console.log(error.message);
            throw error;
        }
    }

    padZero(num: number): string {
        return num < 10 ? `0${num}` : `${num}`;
    }

    padLeadingZeros(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        if (!isNaN(Number(s))) {
            return s;
        }
    }

    getJson(ticket, items, discounts, payments) {
        return new Promise((resolve, reject) => {
            console.log('ticket', ticket);

            const currentTime = new Date();
            const hours = this.padZero(currentTime.getHours());
            const minutes = this.padZero(currentTime.getMinutes());

            const seconds = this.padZero(currentTime.getSeconds());
            let formattedTime = `${hours}:${minutes}:${seconds}`;

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = this.padZero(currentDate.getMonth() + 1); // Los meses en JavaScript son base 0
            const day = this.padZero(currentDate.getDate());

            let formattedDate = `${year}-${month}-${day}`;

            let typeDte;
            let version;
            let control_number;
            if (ticket.fiscal.type == 'invoice') {
                typeDte = '01';
                version = 1;
                control_number = `DTE-${typeDte}-${this.auth.branch_data.fiscal.code}${this.auth.device_data.fiscal_code}-${this.padLeadingZeros(String(ticket.fiscal.current_invoice_number), 15)}`;
            } else if (ticket.fiscal.type == 'ccf') {
                typeDte = '03';
                version = 3;
                control_number = `DTE-${typeDte}-${this.auth.branch_data.fiscal.code}${this.auth.device_data.fiscal_code}-${this.padLeadingZeros(String(ticket.fiscal.current_ccf_number), 15)}`;
            }

            let generation_code = uuidv4().toUpperCase();

            ticket.total = this.components.formatCurrency(ticket.total);

            let total_in_words = writtenNumber(ticket.total, { lang: 'es' })

            const partes = ticket.total.toString().split('.');

            const dolares = writtenNumber(partes[0], { lang: 'es' }).toUpperCase();
            const centavos = writtenNumber(partes[1] || '0', { lang: 'es' }).toUpperCase();
            total_in_words = `${dolares.toUpperCase()} DÓLARES CON ${centavos.toUpperCase()} CENTAVOS`;

            if (partes[1] == 0 || partes[1] == undefined) {
                total_in_words = `${dolares.toUpperCase()} DÓLARES`;
            }

            let json = {
                "nit": this.auth.account_data.fiscal.nit,
                "active": true,
                "passwordPri": this.auth.account_data.fiscal.passwordCert,
                "dteJson": {
                    "identificacion": {
                        "version": version,
                        "ambiente": environment.mh.environment,
                        "tipoDte": typeDte,
                        "numeroControl": control_number,
                        "codigoGeneracion": generation_code,
                        "tipoModelo": 1,
                        "tipoOperacion": 1,
                        "tipoContingencia": null,
                        "motivoContin": null,
                        "fecEmi": formattedDate,
                        "horEmi": formattedTime,
                        "tipoMoneda": "USD"
                    },
                    "emisor": {
                        "nit": this.auth.account_data.fiscal.nit,
                        "nrc": this.auth.account_data.fiscal.nrc,
                        "nombre": this.auth.account_data.fiscal.business_name,
                        "codActividad": String(this.auth.branch_data.activity.code),
                        "descActividad": this.auth.branch_data.activity.value,
                        "nombreComercial": null,
                        "tipoEstablecimiento": this.auth.branch_data.fiscal.branch_type,
                        "direccion": {
                            "departamento": String(this.auth.branch_data.fiscal.depto.code),
                            "municipio": String(this.auth.branch_data.fiscal.munic.code),
                            "complemento": String(this.auth.branch_data.address)
                        },
                        "telefono": this.auth.branch_data.phone,
                        "correo": this.auth.account_data.email,
                        "codEstableMH": null,
                        "codEstable": null,
                        "codPuntoVentaMH": null,
                        "codPuntoVenta": null
                    },
                    "receptor": <any>{
                        "tipoDocumento": null,
                        "numDocumento": null,
                        "nombre": 'Consumidor Final',
                        "correo": null,
                        "nrc": null, //Opcional null
                        "telefono": null, //Opcional null
                        "codActividad": null, //Opcional null
                        "descActividad": null, //Opcional null
                        "direccion": null, //Opcional null
                    },
                    "cuerpoDocumento": [],
                    "resumen": {},
                    "documentoRelacionado": null,
                    "otrosDocumentos": null,
                    "ventaTercero": null,
                    "extension": null,
                    "apendice": null
                }
            }

            let resumen;
            let total_discount = 0;
            const is_exempt = false;


            items.forEach(item => {
                if (discounts && discounts.length > 0) {
                    const taxes = item.is_variant ? item.parent?.taxes_item : item?.taxes_item;
                    total_discount += item.discount;

                    taxes.forEach(tax => {
                        if (!tax.exempt && (!tax.iva || ticket.fiscal.type !== 'invoice')) {
                            total_discount -= tax.discount;
                        }
                    });
                }
            });

            //Esto une todos los taxes_item y los agrupa
            const taxes = items.reduce((accum, item) => {
                let currentTaxes: any[] = [];

                if (item.is_promotion) {
                    currentTaxes = item.x_items.concat(item.y_items)
                        .flatMap(element => {
                            const rawTaxes = element.is_variant ? element.parent?.taxes_item : element?.taxes_item;
                            return (rawTaxes || []).map(tax => ({
                                ...tax,
                                item_key: item.$key
                            }));
                        });
                } else {
                    const rawTaxes = item.is_variant ? item.parent?.taxes_item : item?.taxes_item || [];
                    currentTaxes = rawTaxes.map(tax => ({
                        ...tax,
                        item_key: item.$key
                    }));
                }

                return accum.concat(currentTaxes);
            }, []);

            let isExempt = false;

            const all_tributos = taxes.reduce((tributos, tax) => {
                if (!tax.dte_tax) {
                    tax.dte_tax = {
                        code: "20",
                        description: "Impuesto al Valor Agregado 13%"
                    }
                }
                const codigo = tax.dte_tax?.code;
                const descripcion = tax.dte_tax?.description;
                let valor = Number(tax.value || 0);
                const existing = tributos.find(t => t.codigo === codigo);

                if (tax.discount) valor -= tax.discount;

                if (!tax.exempt) {
                    if (existing) {
                        existing.valor += valor;
                        existing.valor = setDecimals(existing.valor, 2);
                    } else {
                        tributos.push({
                            codigo,
                            descripcion,
                            valor: setDecimals(valor, 2)
                        });
                    }
                } else {
                    if (tax.iva) isExempt = true;
                }

                return tributos;
            }, []);

            const other_tributos = all_tributos.filter(t => t.codigo !== '20');

            let total_iva = all_tributos
                .filter(tax => tax.codigo === '20')
                .reduce((sum, tax) => sum + Number(tax.valor || 0), 0);

            if (total_iva < 0) total_iva = 0;

            if (ticket.fiscal.type == 'invoice') {

                resumen = {
                    "totalNoSuj": 0,
                    "totalExenta": 0,
                    "totalGravada": setDecimals(ticket.subtotal + total_iva + total_discount + ticket.iva_rete),
                    "subTotalVentas": setDecimals(ticket.subtotal + total_iva + total_discount + ticket.iva_rete),
                    "subTotal": setDecimals(ticket.subtotal + total_iva + ticket.iva_rete),
                    "montoTotalOperacion": setDecimals(ticket.subtotal + ticket.hidden_taxes - ticket.exempt + ticket.iva_rete),
                    "totalNoGravado": setDecimals(ticket.tip),
                    "totalPagar": setDecimals(Number(ticket.total)),
                    "descuGravada": setDecimals(total_discount),
                    "totalDescu": setDecimals(total_discount),
                    "totalIva": setDecimals(total_iva),
                    "totalLetras": total_in_words,
                    "ivaRete1": setDecimals(ticket.iva_rete),
                    "porcentajeDescuento": 0,
                    "descuNoSuj": 0,
                    "descuExenta": 0,
                    "tributos": other_tributos.length > 0 ? other_tributos : null,
                    "reteRenta": 0,
                    "condicionOperacion": 1,
                    "pagos": [],
                    "saldoFavor": 0,
                    "numPagoElectronico": null
                }

                if (ticket.iva_rete > 0) {
                    resumen['ivaRete1'] = setDecimals(ticket.iva_rete);
                }

                if (ticket.client !== undefined) {
                    if (ticket.client.type == 'regular') {
                        json.dteJson.receptor = {
                            "tipoDocumento": ticket.client.document_type.code ? String(ticket.client.document_type.code) : null,
                            "numDocumento": ticket.client.document ? ticket.client.document : null,
                        }
                    } else {
                        json.dteJson.receptor = {
                            "tipoDocumento": "36",
                            "numDocumento": ticket.client.nit,
                        }
                    }

                    json.dteJson.receptor = {
                        ...json.dteJson.receptor,
                        "nombre": ticket.client.name,
                        "correo": ticket.client.email,
                        "nrc": ticket.client.nrc ? ticket.client.nrc : null,
                        "telefono": ticket.client.phone ? ticket.client.phone : null,
                        "codActividad": ticket.client.activity ? String(ticket.client.activity.code) : null,
                        "descActividad": ticket.client.activity ? ticket.client.activity.value : null,
                        "direccion": null,
                    }

                    if (ticket.client.depto && ticket.client.munic && ticket.client) {
                        json.dteJson.receptor["direccion"] = {
                            "departamento": ticket.client.depto.code.toString(),
                            "municipio": ticket.client.munic.code.toString(),
                            "complemento": ticket.client.address.toString()
                        }
                    }
                }

                if (isExempt) {
                    resumen.totalGravada = 0;
                    resumen.totalExenta = setDecimals(ticket.subtotal + total_discount);
                    resumen.subTotalVentas = setDecimals(ticket.subtotal + total_discount);
                    resumen.subTotal = setDecimals(ticket.subtotal);
                    resumen.descuGravada = 0;
                    resumen.descuExenta = setDecimals(total_discount);
                    resumen.totalDescu = setDecimals(total_discount);
                }
            } else if (ticket.fiscal.type == 'ccf') {

                resumen = {
                    "totalNoSuj": 0,
                    "totalExenta": 0,
                    "totalGravada": setDecimals(ticket.subtotal + total_discount + ticket.iva_rete),
                    "subTotalVentas": setDecimals(ticket.subtotal + total_discount + ticket.iva_rete),
                    "descuNoSuj": 0,
                    "descuExenta": 0,
                    "descuGravada": setDecimals(total_discount),
                    "porcentajeDescuento": 0,
                    "totalDescu": setDecimals(total_discount),
                    "subTotal": setDecimals(ticket.subtotal + ticket.iva_rete),
                    "ivaPerci1": 0,
                    "ivaRete1": setDecimals(ticket.iva_rete),
                    "reteRenta": 0,
                    "montoTotalOperacion": setDecimals(ticket.subtotal + ticket.hidden_taxes + ticket.taxes - ticket.exempt + ticket.iva_rete),
                    "totalNoGravado": setDecimals(ticket.tip),
                    "totalPagar": setDecimals(ticket.subtotal + ticket.tip + ticket.hidden_taxes + ticket.taxes - ticket.exempt),
                    "totalLetras": total_in_words,
                    "saldoFavor": 0,
                    "condicionOperacion": 1,
                    "pagos": [],
                    "numPagoElectronico": null,
                    "tributos": all_tributos,
                }

                if (isExempt) {
                    resumen.totalExenta = setDecimals(ticket.subtotal + total_discount)
                    resumen.totalGravada = 0;
                    resumen.subTotal = setDecimals(ticket.subtotal);
                    resumen.descuGravada = 0;
                    resumen.descuExenta = setDecimals(total_discount);
                    resumen.totalDescu = setDecimals(total_discount);

                }

                if (ticket.client == undefined) {
                    //2DO agregar excepcion
                    console.log('no se puede pasar debe de agregar cliente de ccf');
                } else {
                    json.dteJson.receptor = {
                        "nrc": ticket.client.nrc,
                        "nit": ticket.client.nit,
                        "nombre": ticket.client.name,
                        "codActividad": String(ticket.client.activity.code),
                        "descActividad": ticket.client.activity.value,
                        "correo": ticket.client.email,
                        "nombreComercial": ticket.client.name,
                        "direccion": {
                            "departamento": String(ticket.client.depto.code),
                            "municipio": String(ticket.client.munic.code),
                            "complemento": String(ticket.client.address)
                        },
                        "telefono": ticket.client.phone
                    }
                }
            }

            let counter_items = 1;

            items.forEach((item, index) => {
                let element_item;

                let name = item.name;
                if (item.is_promotion) {
                    name = item.promotion.name;
                }
                if (item.is_variant) {
                    name = `${item.parent.name}-${item.name}`;
                }

                const taxes_item = taxes.filter(tax => tax.item_key === item.$key && !tax.exempt);

                const other_tributos = taxes_item
                    .filter(tax => !tax.exempt)
                    .filter(tax => tax.dte_tax.code !== '20')
                    .map(tax => tax.dte_tax.code);

                let iva_item = taxes_item
                    .filter(tax => !tax.exempt)
                    .filter(tax => tax.iva)
                    .reduce((sum, tax) => sum + Number(tax.value || 0), 0);

                let item_price = item.price - (item.hidden_taxes / item.quantity);
                item_price += (iva_item / item.quantity);

                if (ticket.fiscal.type == 'invoice') {

                    element_item = {
                        "numItem": counter_items++,
                        "descripcion": name,
                        "tipoItem": 1,
                        "uniMedida": 59,
                        "cantidad": item.quantity,
                        "precioUni": setDecimals(item_price, 8),
                        "ventaGravada": setDecimals((item_price * item.quantity), 8),
                        "ivaItem": setDecimals(iva_item, 8),
                        "tributos": other_tributos.length > 0 ? other_tributos : null,
                        "codigo": null,
                        "montoDescu": 0,
                        "ventaNoSuj": 0,
                        "ventaExenta": 0,
                        "psv": 0,
                        "noGravado": 0,
                        "numeroDocumento": null,
                        "codTributo": null
                    }

                    if (isExempt) {
                        element_item.ventaGravada = 0;
                        element_item.ventaExenta = setDecimals(item_price * item.quantity, 8);
                    }

                } else if (ticket.fiscal.type == 'ccf') {

                    const tributos = [...new Set(taxes_item.map(e => e.dte_tax.code))];
                    item_price -= (iva_item / item.quantity);

                    element_item = {
                        "numItem": counter_items++,
                        "tipoItem": 1,
                        "descripcion": name,
                        "cantidad": item.quantity,
                        "precioUni": setDecimals(item_price, 8),
                        "ventaGravada": setDecimals(Number(item_price) * Number(item.quantity), 8),
                        "tributos": tributos.length > 0 ? tributos : null,
                        "numeroDocumento": null,
                        "codigo": null,
                        "codTributo": null,
                        "uniMedida": 59,
                        "montoDescu": 0,
                        "ventaNoSuj": 0,
                        "ventaExenta": 0,
                        "psv": 0,
                        "noGravado": 0
                    }


                    if (isExempt) {
                        element_item.ventaGravada = 0;
                        element_item.ventaExenta = setDecimals(item_price * item.quantity, 8);
                    }
                }

                json.dteJson.cuerpoDocumento.push(element_item)
            });

            if (ticket.tip > 0) {
                if (ticket.fiscal.type == 'invoice') {
                    json.dteJson.cuerpoDocumento.push({
                        "numItem": counter_items++,
                        "tipoItem": 2,
                        "cantidad": 1,
                        "codigo": null,
                        "uniMedida": 99,
                        "descripcion": 'Propina',
                        "precioUni": 0,
                        "montoDescu": 0,
                        "ventaNoSuj": 0,
                        "ventaExenta": 0,
                        "ventaGravada": 0,
                        "tributos": null,
                        "psv": 0,
                        "noGravado": setDecimals(ticket.tip),
                        "ivaItem": 0,
                        "numeroDocumento": null,
                        "codTributo": null
                    })
                } else if (ticket.fiscal.type == 'ccf') {
                    json.dteJson.cuerpoDocumento.push({
                        "numItem": counter_items++,
                        "tipoItem": 2,
                        "numeroDocumento": null,
                        "codigo": null,
                        "codTributo": null,
                        "descripcion": 'Propina',
                        "cantidad": 1,
                        "uniMedida": 99,
                        "precioUni": 0,
                        "montoDescu": 0,
                        "ventaNoSuj": 0,
                        "ventaExenta": 0,
                        "ventaGravada": 0,
                        "tributos": null,
                        "psv": 0,
                        "noGravado": setDecimals(ticket.tip)
                    });
                }
            }

            payments.forEach(payment => {

                let payment_code = '01';

                if (payment.method == 'card') {
                    payment_code = '02';
                } else if (payment.method == 'check') {
                    payment_code = '04';
                } else if (payment.method == 'transfer') {
                    payment_code = '05';
                } else if (payment.method == 'giftcard') {
                    payment_code = '99';
                }

                resumen['pagos'].push({
                    "montoPago": payment.total,
                    "referencia": null,
                    "codigo": payment_code,
                    "plazo": null,
                    "periodo": null
                })
            });

            if (ticket.type == 'delivery' || ticket.was_credit == true) {
                resumen.condicionOperacion = 2;
                resumen.pagos = null;
            }
            json.dteJson.resumen = resumen;

            resolve(json)
        })
    }

    invalidationJson(ticket, note, doc) {
        return new Promise((resolve, reject) => {
            const currentTime = new Date();
            const hours = this.padZero(currentTime.getHours());
            const minutes = this.padZero(currentTime.getMinutes());

            const seconds = this.padZero(currentTime.getSeconds());
            let formattedTime = `${hours}:${minutes}:${seconds}`;

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = this.padZero(currentDate.getMonth() + 1); // Los meses en JavaScript son base 0
            const day = this.padZero(currentDate.getDate());

            let formattedDate = `${year}-${month}-${day}`;

            let generation_code = uuidv4().toUpperCase();
            let json = {
                "nit": this.auth.account_data.fiscal.nit,
                "active": true,
                "passwordPri": this.auth.account_data.fiscal.passwordCert,
                "dteJson": {
                    "identificacion": {
                        "version": 2,
                        "ambiente": environment.mh.environment,
                        "codigoGeneracion": generation_code,
                        "fecAnula": formattedDate,
                        "horAnula": formattedTime,
                    },
                    "emisor": {
                        "nit": this.auth.account_data.fiscal.nit,
                        "nombre": this.auth.account_data.fiscal.business_name,
                        "tipoEstablecimiento": this.auth.branch_data.fiscal.branch_type,
                        "telefono": this.auth.branch_data.phone,
                        "correo": this.auth.account_data.email,
                        "codEstable": this.auth.branch_data.fiscal.code,
                        "codPuntoVenta": this.auth.device_data.fiscal_code,
                        "nomEstablecimiento": this.auth.branch_data.name
                    },
                    "documento": {
                        "tipoDte": ticket.fiscal.dte.json.identificacion.tipoDte,
                        "codigoGeneracion": ticket.fiscal.dte.json.identificacion.codigoGeneracion,
                        "selloRecibido": ticket.fiscal.dte.selloRecibido,
                        "numeroControl": ticket.fiscal.dte.json.identificacion.numeroControl,
                        "fecEmi": ticket.fiscal.dte.json.identificacion.fecEmi,
                        "montoIva": setDecimals(ticket.hidden_taxes),
                        "codigoGeneracionR": null, //Esto solamente si se reemplaza por algun otro
                        "tipoDocumento": null,
                        "numDocumento": null,
                        "nombre": null,
                    },
                    "motivo": {
                        "tipoAnulacion": 2,
                        "motivoAnulacion": note,
                        "nombreResponsable": this.auth.account_data.user.name,
                        "tipDocResponsable": String(doc.document_type.code),
                        "numDocResponsable": String(doc.document),
                        "nombreSolicita": String(ticket.client.name),
                    }
                }
            }

            if (ticket.client.legal_person) {
                json.dteJson.motivo['tipDocSolicita'] = '36';
                json.dteJson.motivo['numDocSolicita'] = String(ticket.client.nit);
            } else {
                json.dteJson.motivo['tipDocSolicita'] = (!ticket.client.document_type.code) ? '' : String(ticket.client.document_type.code);
                json.dteJson.motivo['numDocSolicita'] = (!ticket.client.document) ? '' : String(ticket.client.document);
            }

            if (ticket.fiscal.dte.json.receptor) {
                let tipoDocumento;
                let numDocumento;

                if (ticket.fiscal.dte.json.receptor.nit) {
                    tipoDocumento = '36'
                    numDocumento = ticket.fiscal.dte.json.receptor.nit;
                } else {
                    tipoDocumento = ticket.fiscal.dte.json.receptor.tipoDocumento;
                    numDocumento = ticket.fiscal.dte.json.receptor.numDocumento;
                }
                json.dteJson.documento.tipoDocumento = tipoDocumento;
                json.dteJson.documento.numDocumento = numDocumento;
            }

            resolve(json);
        })
    }

    // sendContingency(ticket) {
    //     return new Promise(async (resolve, reject) => {

    //     })
    // }

}